<template>
	<div class="mt-10" v-if="students?.length">
		<div class="flex items-center justify-between">
			<div class="font-semibold text-neutral-700">
				Danh sách học sinh được nhắc đánh giá định kỳ
			</div>
			<div>
				<button
					type="button"
					class="
						button-p
						btn--ghost
						text-center
						mr-3
						px-6
						whitespace-nowrap
						w-fit
					"
					@click="addStudents"
				>
					Thêm học sinh
				</button>
			</div>
		</div>
		<div class="shadow-sm sm:rounded-2xl mt-3">
			<div class="__record__table overflow-x-auto scroll-bar">
				<div class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full">
					<table class="min-w-full divide-y text-neutral-200">
						<thead class="bg-neutral-100 h-16">
							<tr>
								<th
									scope="col"
									class="
										px-6
										py-3
										text-left text-xs
										font-semibold
										text-neutral-600
										uppercase
										tracking-wider
										w-16
										whitespace-nowrap
									"
								>
									STT
								</th>
								<th
									scope="col"
									class="
										px-6
										py-3
										text-left text-xs
										font-semibold
										text-neutral-600
										uppercase
										tracking-wider
										whitespace-nowrap
										w-32
									"
								>
									Tên học sinh
								</th>
								<th
									scope="col"
									class="
										px-6
										py-3
										text-left text-xs
										font-semibold
										text-neutral-600
										uppercase
										tracking-wider
										whitespace-nowrap
									"
								>
									Tuổi
								</th>
								<th
									scope="col"
									class="
										px-6
										py-3
										text-left text-xs
										font-semibold
										text-neutral-600
										uppercase
										tracking-wider
										whitespace-nowrap
									"
								>
									Mô hình
								</th>
								<th
									scope="col"
									class="
										px-6
										py-3
										text-left text-xs
										font-semibold
										text-neutral-600
										uppercase
										tracking-wider
										whitespace-nowrap
									"
								>
									bắt đầu
								</th>
								<th
									scope="col"
									class="
										px-6
										py-3
										text-left text-xs
										font-semibold
										text-neutral-600
										uppercase
										tracking-wider
										whitespace-nowrap
									"
								>
									chu kì
								</th>
							</tr>
						</thead>
						<tbody>
							<tr
								@click="
									$router.push(
										isAdmin &&
											!['pending'].includes(person.state)
											? `/record/student/${person.id}`
											: `/record/student/${person.id}/info`
									)
								"
								v-for="(person, personIdx) in students"
								:key="person.id"
								:class="
									personIdx % 2 === 0
										? 'bg-white'
										: 'bg-neutral-50'
								"
								class="
									text-neutral-700
									hover:bg-orange-50
									cursor-pointer
								"
							>
								<td>
									<div class="px-6 py-4 text-neutral-700">
										{{ personIdx + 1 }}
									</div>
								</td>
								<td
									class="px-6 py-4 text-neutral-700"
									style="width: 250px"
								>
									<div class="flex items-center">
										<div class="relative">
											<img
												class="
													shadow-sm
													inline-block
													h-6
													w-6
													rounded-full
												"
												:src="
													person?.profile_photo?.w200
												"
												alt=""
												v-if="
													person?.profile_photo?.w200
												"
											/>
											<span
												v-else
												class="
													inline-flex
													items-center
													justify-center
													h-6
													w-6
													rounded-full
												"
												:style="{
													background:
														person?.profile_photo
															?.default?.color,
												}"
											>
												<span
													class="
														font-medium
														leading-none
														text-white text-xs
													"
													>{{
														person?.profile_photo
															?.default?.initial
													}}</span
												>
											</span>
											<div
												v-if="person.state !== 'active'"
												style="
													background-color: rgba(
														241,
														162,
														103,
														0.5
													);
												"
												class="
													absolute
													transform
													-translate-x-1/2
													-translate-y-1/2
													top-1/2
													left-1/2
													h-6
													w-6
													rounded-full
													flex
													items-center
													justify-center
												"
											>
												<svg
													width="14"
													height="14"
													viewBox="0 0 40 40"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M9.84364 16.0997V10.2496C9.84364 4.86466 14.3907 0.5 20 0.5C25.6093 0.5 30.1564 4.865 30.1564 10.2496V16.0997C33.5218 16.0997 36.25 18.7188 36.25 21.9497V33.6499C36.25 36.8812 33.5218 39.5 30.1564 39.5H9.84364C6.47821 39.5 3.75 36.8812 3.75 33.6499V21.9497C3.75 18.7188 6.47821 16.0997 9.84364 16.0997V16.0997ZM26.0936 16.0997V10.2496C26.0936 7.01866 23.3654 4.3995 20 4.3995C16.6346 4.3995 13.9064 7.01866 13.9064 10.2496V16.0997H26.0936ZM20 23.9C21.1218 23.9 22.0311 24.7729 22.0311 25.8499V29.7501C22.0311 30.8271 21.1218 31.7 20 31.7C18.8782 31.7 17.9689 30.8271 17.9689 29.7501V25.8499C17.9689 24.7729 18.8782 23.9 20 23.9Z"
														fill="#FAF5F1"
													/>
												</svg>
											</div>
										</div>
										<div
											class="
												ml-4
												text-orange-600
												font-semibold
											"
											style="max-width: 150px"
										>
											{{ person.name }}
										</div>
									</div>
								</td>
								<td>
									<div
										class="
											px-6
											py-4
											whitespace-nowrap
											text-neutral-700
										"
									>
										{{ person.age }}
									</div>
								</td>
								<td
									class="
										px-6
										py-4
										whitespace-nowrap
										text-neutral-700
									"
									style="min-width: 156px"
								>
									<div class="flex items-center">
										<div
											class="p-2"
											v-if="person?.has_personal_class"
										>
											<img
												class="w-5 h-5"
												src="@/assets/images/icons/class-teacher.png"
												alt=""
											/>
										</div>
										<div
											class="p-2"
											v-if="person?.has_day_care_class"
										>
											<img
												class="w-5 h-5"
												src="@/assets/images/icons/spoon.png"
												alt=""
											/>
										</div>
										<div
											class="p-2"
											v-if="person?.has_group_class"
										>
											<img
												class="w-5 h-5"
												src="@/assets/images/icons/group.png"
												alt=""
											/>
										</div>
									</div>
								</td>
								<td>
									<div
										v-if="person.last_renew_at"
										class="px-6 py-4 text-neutral-700"
									>
										{{
											$filters.formatDateTime(
												person.last_renew_at
											)
										}}
									</div>
								</td>
								<td>
									<div class="px-6 py-4 text-neutral-700">
										{{ person.number_of_cycle ?? 0 }}
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div
		v-else
		class="w-full h-full flex items-center justify-center flex-col mt-20"
	>
		<img
			src="@/assets/images/illustrations/not_found.png"
			alt=""
			height="250"
			width="250"
		/>
		<div class="text-neutral-500 text-lg max-w-lg text-center">
			Chưa có học sinh nào trong danh sách học sinh được nhắc đánh giá
			định kỳ
		</div>
		<button
			type="button"
			class="
				mt-6
				h-12
				button-p
				btn--ghost
				text-center
				mr-3
				px-6
				whitespace-nowrap
				w-fit
			"
			@click="addStudents"
		>
			Thêm học sinh
		</button>
	</div>
</template>

<script>
import { _ROUTER_NAME } from '@/enums';
import { $api } from '@/services';

export default {
	name: 'PeriodicAssessment',
	props: {
		org: {
			type: Object,
			required: true,
		},
	},

	computed: {
		isAdmin() {
			return this.$store.getters.isAdmin;
		},
	},

	data() {
		return {
			students: [],
		};
	},
	created() {
		this.fetchStudentInPeriodicAssessment();
	},
	methods: {
		addStudents() {
			this.$router.push({
				name: _ROUTER_NAME.SETUP_PERIODIC_ASSESSMENT_ADD_STUDENT,
			});
		},
		async fetchStudentInPeriodicAssessment() {
			try {
				const {
					data: { data },
				} = await $api.org.getPeriodicAssessment();
				this.students = data ?? [];
			} catch (e) {
				console.log(e);
			}
		},
	},
};
</script>
